import { DataBean } from "../DataBean";


export class HiringModalityStage extends DataBean {

    public async getHiringModalityStageCatalog(idHiringModality: number, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getHiringModalityStageCatalog_Number_Number_Number", [idHiringModality, page, recordsPerPage]);
    }

}